import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

export default () => (
  <div>
    <ClipLoader color={"blue"} size={35} />
  </div>
);
